import type { FC, ReactNode } from 'react'

interface RouteAccentProps {
    className?: string
    color?: string
}

/* A small running-route flourish — a winding path that traces itself in,
   capped with start/finish nodes. Used as a brand-on motif under page
   titles instead of a plain rule. */
export const RouteAccent: FC<RouteAccentProps> = ({
    className,
    color = '#E94E1B'
}): ReactNode => {
    return (
        <svg
            viewBox='0 0 240 24'
            fill='none'
            className={className}
            aria-hidden='true'
        >
            <path
                d='M3 18 C 30 18, 40 6, 70 7 S 118 18, 150 12 S 208 4, 237 11'
                stroke={color}
                strokeWidth='2'
                strokeLinecap='round'
                strokeDasharray='600'
                strokeDashoffset='600'
                style={{ animation: 'route-dash 2.4s ease-out 0.2s forwards' }}
            />
            <circle cx='3' cy='18' r='3' fill={color} />
            <circle cx='237' cy='11' r='3' fill={color} />
        </svg>
    )
}
